document.addEventListener("DOMContentLoaded", function () {

	/*=========================================
	    ELEMENTS
	=========================================*/
	const assessmentAnswers = {};
    const assesementRowScore = assesementWeightedScore = {};
	const home = document.getElementById("assessment-home");
	const screens = [
		home,
		document.getElementById("assessment-step-1"),
		document.getElementById("assessment-step-2"),
		document.getElementById("assessment-step-3"),
		document.getElementById("assessment-step-4"),
		document.getElementById("assessment-step-5"),
		document.getElementById("assessment-result")
	];

	/*=========================================
	    SHOW SCREEN
	=========================================*/
	function showScreen(id) {
		screens.forEach(function (screen) {
			if (screen) {
				screen.style.display = "none";
			}
		});
		const active = document.getElementById(id);
		if (active) {
			active.style.display = "flex";
		}
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	}

	/*=========================================
	    START BUTTON
	=========================================*/
	document.querySelectorAll(".acne-start-btn").forEach(function (btn) {
		btn.addEventListener("click", function () {
			showScreen("assessment-step-1");
			updateProgress("assessment-step-1");
		});
	});

	/*=========================================
	    BACK HOME
	=========================================*/
	document.querySelectorAll(".acne-back-home").forEach(function (btn) {
		btn.onclick = function () {
			showScreen("assessment-home");
		}
	});

	/*=========================================
	    OPTION SELECTION
	=========================================*/
	document.querySelectorAll(".question-card").forEach(function (card, index) {
        let buttons = card.querySelectorAll(".acne-option-btn");
        if(!card.dataset.weightedScore){
            buttons.forEach(function (button) {
                button.onclick = function () {
                    buttons.forEach(function (btn) {
                        btn.classList.remove("active");
                        const dot = btn.querySelector('[data-dc-tpl="123"]');
                        if (dot) {
                            dot.style.opacity = "0";
                        }
                    });
                    this.classList.add("active");
                    const dot = this.querySelector('[data-dc-tpl="123"]');
                    if (dot) {
                        dot.style.opacity = "1";
                    }
                    validateCurrentStep(this);
                }
            });
        }else{
            if (card.id == 'acne-distributor'){
                let totalRowScore = 0;
                let question = card.querySelector('[data-dc-tpl="103"] span').innerText;
                card.querySelectorAll('.distribution-row').forEach(function(distributor_row){
                    let buttons = distributor_row.querySelectorAll("button");
                    buttons.forEach(function (btn, btn_index) {
                        btn.onclick = async function () {
                            buttons.forEach(function (b) {
                                b.classList.remove("active");
                            });
                            this.classList.add("active");
                            totalRowScore += Number(this.dataset.rawScore);
                            assessmentAnswers[question.replaceAll(' ','_')] = {
                                weightedScore: 15,
                                rowScore: totalRowScore,
                                finalWeightedScore: totalRowScore,
                                overallWeightedScore:15
                            }
                        	// console.log('assessmentAnswers',assessmentAnswers);

                            validateCurrentStep(this);
                        }
                    });
                });
            }else{
                buttons.forEach(function (button) {
					button.onclick = function () {

						buttons.forEach(function (btn) {
							btn.classList.remove("active");

							const dot = btn.querySelector('[data-dc-tpl="123"]');
							if (dot) {
								dot.style.opacity = "0";
							}
						});

						this.classList.add("active");

						const dot = this.querySelector('[data-dc-tpl="123"]');
						if (dot) {
							dot.style.opacity = "1";
						}

						let question = card.querySelector('[data-dc-tpl="103"] span').innerText;

						assessmentAnswers[question.replaceAll(' ', '_')] = {
							weightedScore: parseFloat(card.dataset.weightedScore),
							name: this.dataset.name,
							rowScore: Number(this.dataset.rawScore),
							finalWeightedScore: Number(this.dataset.rawScore) * parseFloat(card.dataset.weightedScore),
							overallWeightedScore: parseFloat(card.dataset.weightedOverallScore)
						};

						// console.log("assessmentAnswers", assessmentAnswers);

						validateCurrentStep(this);
					}
				});
            }
        }
	});

	/*=========================================
	    VALIDATION
	=========================================*/
	function validateCurrentStep(element) {
		let step;
		if (element.id && element.id.startsWith("assessment-step-")) {
			step = element;
		}
		else {
			step = element.closest(
				"#assessment-step-1, #assessment-step-2, #assessment-step-3, #assessment-step-4, #assessment-step-5"
			);
		}
		if (!step) return;
		let valid = true;

		/*-----------------------------------
		    Normal Questions
		------------------------------------*/
		const cards = step.querySelectorAll(".question-card");
		cards.forEach(function (card) {
			const options = card.querySelectorAll(".acne-option-btn");
			if (options.length) {
				if (!card.querySelector(".acne-option-btn.active")) {
					valid = false;
				}
			}
		});
        
		/*-----------------------------------
		    Distribution Questions (Step-3)
		------------------------------------*/
		const rows = step.querySelectorAll(".distribution-row");
		if (rows.length) {
			rows.forEach(function (row) {
				if (!row.querySelector("button.active")) {
					valid = false;
				}
			});
		}

		/*-----------------------------------
		STEP-4 PRODUCTS
		------------------------------------*/
		if (step.id == "assessment-step-4") {
			const selectedProducts =
				step.querySelectorAll('[data-dc-tpl="133"].active').length;
			const otherProduct =
				step.querySelector('[data-dc-tpl="139"]');
			const medication =
				step.querySelector('[data-dc-tpl="141"]');
			if (
				selectedProducts == 0 &&
				otherProduct.value.trim() == "" &&
				medication.value.trim() == ""
			) {
				valid = false;
			}
		}
		if (step.id == "assessment-step-5") {
			const groups = step.querySelectorAll('[data-dc-tpl="153"]');
			groups.forEach(function (group) {
				if (!group.querySelector("button.active")) {
					valid = false;
				}
			});
		}
		/*-----------------------------------
			STEP-1 EMAIL & PHONE
		------------------------------------*/
		if (step.id === "assessment-step-1") {

			const email = document.getElementById("user-email");
			const phone = document.getElementById("user-phone");

			if (email) {
				const emailValid =
					email.value.trim() !== "" &&
					/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim());

				if (!emailValid) {
					valid = false;
				}
			}

			if (phone) {
				const phoneValid = /^[0-9]{6,15}$/.test(phone.value.trim());

				if (!phoneValid) {
					valid = false;
				}
			}
		}
		/*-----------------------------------
		    Continue Button
		------------------------------------*/
		const continueBtn = step.querySelector(".continue-btn");
		if (!continueBtn) return;
		continueBtn.disabled = !valid;
		if (valid) {
			continueBtn.classList.add("enabled");
			continueBtn.style.background = "#0d8f83";
			continueBtn.style.color = "#fff";
			continueBtn.style.cursor = "pointer";
			continueBtn.style.opacity = "1";
		}
		else {
			continueBtn.classList.remove("enabled");
			continueBtn.style.background = "#dbe4e1";
			continueBtn.style.color = "#a3b1ad";
			continueBtn.style.cursor = "not-allowed";
			continueBtn.style.opacity = "1";
		}
	}

	/*=========================================
	STEP NAVIGATION
	=========================================*/
	const nextMap = {
		"step1-continue": "assessment-step-2",
		"step2-continue": "assessment-step-3",
		"step3-continue": "assessment-step-4",
		"step4-continue": "assessment-step-5",
		"step5-continue": "assessment-result"
	};

	function calculateOverallScore() {
		let total = 0;
		Object.keys(assessmentAnswers).forEach(function (key) {
			if (key.endsWith("_score")) {
				total += Number(assessmentAnswers[key]);
			}
		});
		return total;
	}
	Object.keys(nextMap).forEach(function (id) {
		const btn = document.getElementById(id);
		if (!btn) return;
		btn.onclick = function () {
			if (btn.disabled) return;
			if (id === "step5-continue") {
				const totalRowScore = Object.values(assessmentAnswers)
                    .reduce((sum, item) => sum + Number(item.rowScore || 0), 0);

                const totalFinalWeightedScore = Object.values(assessmentAnswers)
                    .reduce((sum, item) => sum + Number(item.finalWeightedScore || 0), 0);
				const overallWeightedScore = Object.values(assessmentAnswers)
                    .reduce((sum, item) => sum + Number(item.overallWeightedScore || 0), 0);
				// Overall Score
                const OverallScore = (totalRowScore/overallWeightedScore) * 100
				document.getElementById("overall-score").innerText = Math.round(OverallScore);

				// Severity Text
				const severityText = document.querySelector('[data-dc-tpl="177"]');
				if (severityText) {
					if (OverallScore <= 20) {
						severityText.innerText = "Minimal Acne";
					}
					else if (OverallScore <= 40) {
						severityText.innerText = "Mild Acne";
					}
                    else if (OverallScore <= 60) {
						severityText.innerText = "Moderate Acne";
					}
                    else if (OverallScore <= 80) {
						severityText.innerText = "Severe Acne";
					}
					else {
						severityText.innerText = "Very Severe Acne";
					}
				}
                updateprogressCircle (OverallScore);
                document.querySelector('span[data-total-w-score]').innerText = totalFinalWeightedScore + '/ '+overallWeightedScore;
                Object.entries(assessmentAnswers).forEach(([key, {
                    rowScore,
                    finalWeightedScore,
                    overallWeightedScore
                }]) => {
                    document.getElementById(key).querySelector('[data-dc-tpl="189"]').innerText = finalWeightedScore + ' / '+overallWeightedScore;
                    const percentage = (finalWeightedScore / overallWeightedScore) * 100;
                    document.getElementById(key).querySelector('[data-dc-tpl="191"]').style.width = percentage+'%';

                });

			}
			showScreen(nextMap[id]);
			updateProgress(nextMap[id]);
		};
	});
    const progressCircle = document.querySelector('[data-dc-tpl="171"]');
    function updateprogressCircle (score) {
        // score = 0 - 100
        const radius = 85;
        const circumference = 2 * Math.PI * radius;

        progressCircle.setAttribute("stroke-dasharray", circumference);

        const offset = circumference - (score / 100) * circumference;
        progressCircle.style.strokeDashoffset = offset;

        // Change color based on score
        let color;

        if (score <= 25) {
            color = "#22c55e";      // Green
        } else if (score <= 50) {
            color = "#eab308";      // Yellow
        } else if (score <= 75) {
            color = "#f59e0b";      // Orange
        } else {
            color = "#ef4444";      // Red
        }

        progressCircle.style.stroke = color;
    }

	/*=========================================
	    BACK BUTTONS
	=========================================*/
	const backMap = {
		0: "assessment-home",
		1: "assessment-step-1",
		2: "assessment-step-2",
		3: "assessment-step-3",
		4: "assessment-step-4",
		5: "assessment-step-5"
	};
	document.querySelectorAll(".back-btn").forEach(function (btn) {
		btn.onclick = function () {
			const back = this.dataset.back;
			if (backMap[back]) {
				showScreen(backMap[back]);
				updateProgress(backMap[back]);
			}
		}
	});

	/*=========================================
	    PROGRESS
	=========================================*/
	function updateProgress(step) {
		const progressBar = document.querySelector("#" + step + " #assessment-progress-bar");
		const progressText = document.querySelector("#" + step + " #assessment-progress-text");
		const stepText = document.querySelector("#" + step + " #assessment-step-text");
		const sidebar = document.querySelectorAll("#" + step + " .sidebar-step");
		let current = 1;
		if (step == "assessment-step-1") current = 1;
		if (step == "assessment-step-2") current = 2;
		if (step == "assessment-step-3") current = 3;
		if (step == "assessment-step-4") current = 4;
		if (step == "assessment-step-5") current = 5;
		if (step == "assessment-result") current = 6;
		let percent = current > 5 ? 100 : current * 20;
		if (progressBar) {
			progressBar.style.width = percent + "%";
		}
		if (progressText) {
			progressText.innerHTML = percent + "% complete";
		}
		if (stepText) {
			if (current <= 5) {
				stepText.innerHTML = "Step " + current + " of 5";
			}
			else {
				stepText.innerHTML = "Assessment Complete";
			}
		}
		sidebar.forEach(function (item, index) {
			item.classList.remove("active", "completed");
			if (index + 1 < current) {
				item.classList.add("completed");
			}
			else if (index + 1 === current) {
				item.classList.add("active");
			}
		});
	}
	document.querySelectorAll('[data-dc-tpl="133"]').forEach(function (btn) {
		btn.addEventListener("click", function (e) {
			e.preventDefault();
			this.classList.toggle("active");
			const box = this.querySelector('[data-dc-tpl="134"]');
			if (this.classList.contains("active")) {
				this.style.borderColor = "#0d8f83";
				this.style.background = "#edf8f7";
				box.style.background = "#0d8f83";
				box.style.borderColor = "#0d8f83";
				box.style.color = "#fff";
				box.innerHTML = "✓";
			}
			else {
				this.style.borderColor = "#e2ebe8";
				this.style.background = "#fff";
				box.style.background = "transparent";
				box.style.borderColor = "#c7d3d1";
				box.innerHTML = "";
			}
			validateCurrentStep(
				document.getElementById("assessment-step-4")
			);
		});
	});
	const other = document.querySelector('[data-dc-tpl="139"]');
	const medicine = document.querySelector('[data-dc-tpl="141"]');
	if (other) {
		other.addEventListener("input", function () {
			validateCurrentStep(
				document.getElementById("assessment-step-4")
			);
		});
	}
	if (medicine) {
		medicine.addEventListener("input", function () {
			validateCurrentStep(
				document.getElementById("assessment-step-4")
			);
		});
	}

	/*=========================================
    STEP-5 OPTIONS
    =========================================*/
	document.querySelectorAll('#assessment-step-5 [data-dc-tpl="153"]').forEach(function (group) {
		const buttons = group.querySelectorAll('button');
		buttons.forEach(function (btn) {
			btn.addEventListener("click", function (e) {
				e.preventDefault();
				buttons.forEach(function (b) {
					b.classList.remove("active");
				});
				this.classList.add("active");
				validateCurrentStep(
					document.getElementById("assessment-step-5")
				);
			});
		});
	});

	const email = document.getElementById("user-email");
	const phone = document.getElementById("user-phone");

	if (email) {
		email.addEventListener("input", function () {
			validateCurrentStep(
				document.getElementById("assessment-step-1")
			);
		});
	}

	if (phone) {
		phone.addEventListener("input", function () {

			this.value = this.value.replace(/\D/g, "").slice(0, 15);

			validateCurrentStep(
				document.getElementById("assessment-step-1")
			);
		});
	}
	
	/*=========================================
	    RESTART BUTTON
	=========================================*/
	const restartBtn = document.getElementById("resart_button");
	if (restartBtn) {
		restartBtn.addEventListener("click", function () {
			location.reload();
		});
	}

	function calculateAssessmentScore() {
		let total = 0;
		Object.keys(assessmentAnswers).forEach(function (key) {
			if (key.endsWith("_score")) {
				total += Number(assessmentAnswers[key]);
			}
		});
		document.getElementById("overall-score").innerText = total;
	}
	const step5Btn = document.getElementById("saveResults");
	if (step5Btn) {

		step5Btn.addEventListener("click", async function () {
			const formData = new FormData();

			formData.append("Date", new Date().toLocaleDateString("en-GB"));

			/* ============================
			Step-1 / Step-2 / Step-5
			============================ */
			formData.append("Date", new Date().toLocaleDateString("en-GB"));

			document.querySelectorAll(".question-card").forEach(function(card){

				const question = card.querySelector('[data-dc-tpl="103"] span')?.innerText.trim();

				if(!question) return;

				const activeBtn = card.querySelector(".acne-option-btn.active");
				const inputValue = card.querySelector("input")?.value.trim(); 

				if(activeBtn && !activeBtn.querySelector('[data-dc-tpl="157"]')){

					formData.append(
						question,
						activeBtn.dataset.name || activeBtn.innerText.trim()
					);

				}else if(activeBtn && activeBtn.querySelector('[data-dc-tpl="157"]')){
					formData.append(
						question,
						activeBtn.dataset.name || activeBtn.querySelector('[data-dc-tpl="157"]').innerText.trim()
					);
				}

			});

			document.querySelectorAll(".questions-card").forEach(function(card){

				const question = card.querySelector('[data-dc-tpl="103"] span')?.innerText.trim();

				if (!question) return;

				const inputValue = card.querySelector("input")?.value.trim();

				if (inputValue) {
					formData.append(question, inputValue);
				}

			});

			/* ============================
			Step-3 Distribution
			============================ */

			document.querySelectorAll(".distribution-row").forEach(function(row){

				const question =
					row.querySelector('[data-dc-tpl="144"]')?.innerText.trim();

				const activeBtn = row.querySelector("button.active");

				if(question && activeBtn){

					formData.append(
						question,
						activeBtn.dataset.name || activeBtn.innerText.trim()
					);

				}

			});

			/* ============================
			Step-4 Products
			============================ */

			const products = [];

			document.querySelectorAll('[data-dc-tpl="133"].active').forEach(function(item){

				products.push(
					item.querySelector('.sc-interp').innerText.trim()
				);

			});

			formData.append("Products Used", products.join(", "));

			/* ============================
			Other Product
			============================ */

			const other = document.querySelector('[data-dc-tpl="139"]');

			formData.append(
				"Products Used",
				other ? other.value : ""
			);

			/* ============================
			Medication
			============================ */

			const medicine = document.querySelector('[data-dc-tpl="141"]');

			formData.append(
				"Medication",
				medicine ? medicine.value : ""
			);

			/* ============================
			Assessment Scores
			============================ */

			Object.entries(assessmentAnswers).forEach(([key,value])=>{

				formData.append(`${key}_Answer`, value.name || "");
				formData.append(`${key}_RowScore`, value.rowScore || "");
				formData.append(`${key}_WeightedScore`, value.weightedScore || "");
				formData.append(`${key}_FinalWeightedScore`, value.finalWeightedScore || "");
				formData.append(`${key}_OverallWeightedScore`, value.overallWeightedScore || "");

			});

			/* ============================
			Debug
			============================ */

			for (const pair of formData.entries()) {
				console.log(pair[0], "=>", pair[1]);
			}

			/* ============================
			Google Sheet
			============================ */

			try{
				console.log("Sending Data...");
				const res = await fetch(
					"https://script.google.com/macros/s/AKfycbzE5R_jrp3HY-JUk5SB60xGWqQOoPaZuGRMDIbZiCp9lvDvREkanQLn_2EhCajXjsO3/exec",
					{
						method: "POST",
						body: formData
					}
					);

					console.log(res);
					console.log(res.status);

					const text = await res.text();
					console.log(text);

			}catch(err){

				console.error(err);

			}

		});
	}
});

